import { AIOptionsStore } from './types';

export const actionsSelector = (s: AIOptionsStore) => s.actions;

export const isAIOptOutShownSelector = (s: AIOptionsStore) => s.aiOptOutShown;

export const aiNameAppliedProjectCuidSelector = (s: AIOptionsStore) =>
  s.aiNameAppliedProjectCuid;
